import React, {Component} from 'react';
import MediaQuery from 'react-responsive';
import DesktopNavigation from './DesktopNavigation';
import MobileNavigation from './MobileNavigation';
import {sizes} from '../../../../utils/uiSizes';
import PropTypes from 'prop-types';

export const DesktopMainNavigation = ({currentUser}) => (
	<MediaQuery minWidth={sizes.desktop}>
	{(matches) => {
		if (matches) {
			return (
				<DesktopNavigation currentUser={currentUser} />
			);
		} else {
			return null;
		}
	}}
</MediaQuery>
);

export const MobileHamburgerNavigation = ({currentUser, onLogoutClick}) => (
	<MediaQuery maxWidth={sizes.desktop-1}>
	{(matches) => {
		if (matches) {
			return (
				<MobileNavigation
				currentUser={currentUser}
			   onLogoutClick={onLogoutClick}
		   />
			);
		} else {
			return null;
		}
	}}
</MediaQuery>
);

class MainNavigation extends Component {
	render() {
		const {
			onLogoutClick,
			currentUser
		} = this.props;
		return (
			<MediaQuery minWidth={sizes.desktop}>
				{(matches) => {
					if (matches) {
						return (
							<DesktopNavigation currentUser={currentUser} />
						);
					} else {
						return (
							<MobileNavigation
							 	currentUser={currentUser}
								onLogoutClick={onLogoutClick}
							/>
						);
					}
				}}
			</MediaQuery>
		);
	}
}

MainNavigation.PropTypes = {
	onLogoutClick : PropTypes.func.isRequired
};

export default MainNavigation;


// WEBPACK FOOTER //
// ./src/modules/common/components/app/MainNavigation.js